<div class="tooltip-dialog" [class.overlay-mode]="isOverlay" [class.floating-label-context]="data?.isFloatingLabelContext">
  <!-- Connection indicator for overlay mode -->
  <div class="tooltip-arrow" 
       *ngIf="isOverlay" 
       [class]="'tooltip-arrow-' + (data?.arrowPosition || 'top')">
  </div>

  <!-- Close button - always visible in top right corner -->
  <button
    mat-icon-button
    class="tooltip-dialog-close"
    (click)="close()"
    aria-label="Close tooltip"
  >
    <mat-icon>close</mat-icon>
  </button>

  <div class="tooltip-dialog-content">
    <!-- Title with bottom padding -->
    <div *ngIf="data.title" class="tooltip-dialog-title">{{ data.title }}</div>
    
    <!-- Content with top padding when title exists -->
    <div
      *ngIf="!data.template"
      [innerHTML]="data.content"
      class="tooltip-content"
      [class.has-title]="data.title"
    ></div>
    <ng-container *ngIf="data.template">
      <div class="tooltip-template-content" [class.has-title]="data.title">
        <ng-container
          *ngTemplateOutlet="
            data.template;
            context: { $implicit: data.data, content: data.content }
          "
        ></ng-container>
      </div>
    </ng-container>
  </div>
</div>